// import polyfills first
require('airship/polyfills')
// initialize error reporting
require('airship/modules/report-error/initialize')

// load in entry-points
import('../../scripts/entry-point-loader.js!../../scripts/get-entry-points')
